
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.841 9.65l-7.5-7.5c-.3-.3-.716-.483-1.175-.483H3.333a1.667 1.667 0 00-1.667 1.667v5.833c0 .458.184.875.492 1.183l7.5 7.5c.3.3.717.484 1.175.484a1.63 1.63 0 001.175-.492l5.834-5.833c.308-.3.491-.717.491-1.175 0-.459-.191-.884-.491-1.184zM4.584 5.834a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zm9.809 6.891l-3.559 3.559-3.558-3.559a2.1 2.1 0 01-.609-1.475A2.083 2.083 0 018.75 9.167c.575 0 1.1.233 1.475.617l.608.6.608-.609a2.085 2.085 0 012.95 2.95z","fill":"currentColor"}})])
          )
        }
      }
    